// removed by extract-text-webpack-plugin
module.exports = {"size":"40px","ingredientContainer":"Gdf341f","ingredientImage":"Gb041a5","ingredientLabel":"G61abb8 Gfbbf38"};